import React, { ReactNode } from 'react'

import { Body, Box, Header, Title } from './BoxDetails.styled'

type BoxDetailsProps = {
    className?: string
    title: string
    bodyClassName?: string
    children: ReactNode
}

export const BoxDetails = ({ className, title, children, bodyClassName }: BoxDetailsProps): JSX.Element => {
    return (
        <Box className={className}>
            <Header>
                <Title>{title}</Title>
            </Header>
            <Body className={bodyClassName}>{children}</Body>
        </Box>
    )
}
